import propertyOrNull from 'contest/utils/property-or-null';

export default {
    create,
    defaultProperties,
    fromJSON,
    equal,
};

function create(properties) {
    return {
        ...defaultProperties(),
        ...properties,
    };
}

function equal(obj1, obj2) {
    return obj1 && obj2 && obj1.userId === obj2.userId;
}

function defaultProperties() {
    return {
        userId: null,
        showUrl: null,
        displayName: null,
        avatarUrl: null,
        isDesigner: false,
        permission: {},
    };
}

// Translate from HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    const data = {
        userId: propertyOrNull(json, 'id'),
        profileUrl: propertyOrNull(json, 'profileUrl'),
        name: propertyOrNull(json, 'name'),
        avatarUrl: propertyOrNull(json, 'avatarUrl'),
        isDesigner: propertyOrNull(json, 'isDesigner'),
        permission: propertyOrNull(json, '_embedded', 'permission'),
        tokens: propertyOrNull(json, '_embedded', 'tokens'),
    };

    return data;
}



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/models/user.js